<template>
  <ValidationObserver ref="form" tag="div">
    <v-slide-y-transition>
      <form v-if="ready && request" @submit.prevent="onSubmit">
        <OwnerInfoForm />
        <BusinessStatusForm />
        <ApplicationContentForm :request="request" />
        <signature @sign="sign = $event" class="pb-8">
          <template v-slot:memorandum>
            <p class="text-center" style="word-break: keep-all">
              상기와 같이 &lt;2024년 우리동네 크라우드펀딩 지원사업_대출형&gt;을 신청하며, 기재
              내용이 사실과 다름이 없음을 확인합니다.
            </p>
          </template>
        </signature>

        <v-btn
          color="primary"
          height="52"
          type="submit"
          block
          tile
          class="font--m-3"
          :disabled="loading"
          :loading="loading"
        >
          제출
        </v-btn>
      </form>
    </v-slide-y-transition>
  </ValidationObserver>
</template>

<script>
import { mapActions } from 'vuex'
import { getFirstErrorMessage } from '@/plugins/veevalidate'

export default {
  props: ['request', 'loading'],
  components: {
    OwnerInfoForm: () => import('./form/OwnerInfoForm.vue'),
    BusinessStatusForm: () => import('./form/BusinessStatusForm.vue'),
    ApplicationContentForm: () => import('./form/ApplicationContentForm.vue'),
    Signature: () => import('./Signature.vue'),
  },
  data() {
    return {
      ready: false,
      sign: null,
    }
  },
  mounted() {
    this.ready = true
  },
  methods: {
    ...mapActions('auth', ['getMe']),

    async onSubmit() {
      const isValid = await this.$refs.form.validate()
      if (isValid === false) {
        await this.$swal.fire({
          html: `<p class="custom-alert__text">
            ${getFirstErrorMessage(this.$refs.form.errors)}
          </p>`,
          confirmButtonText: '확인',
          customClass: { container: 'custom-alert2', actions: 'single' },
        })
        return
      }

      if (!this.sign) {
        await this.$swal.fire({
          html: `<p class="custom-alert__text">
            사인을 해주세요.
          </p>`,
          confirmButtonText: '확인',
          customClass: { container: 'custom-alert2', actions: 'single' },
        })
        return
      }

      this.$emit('success')
    },
  },
}
</script>

<style lang="scss" scoped></style>
